import CourseGradeRecordDataStore from '../../datastores/GradeRecordStore';

export default class CourseGradeRecordDataStoreGraphQL
  implements CourseGradeRecordDataStore
{
  async getCoursesGradeRecord() {
    return [
      {
        name: '2020 - Ciclo 1 Marzo',
        items: [
          {
            cycle: '01',
            courseName: 'INGLÉS I',
            grade: '15',
            approvalStatus: 'Aprobado',
            catalogNumber: '100000N03I',
            numberTimes: '1',
            weeklyHours: '3.00',
            credits: '3.00',
            section: '20477'
          },
          {
            cycle: '01',
            courseName: 'AUTOCONOCIMIENTO',
            grade: '11',
            approvalStatus: 'Desaprobado',
            catalogNumber: '100000PS22',
            numberTimes: '1',
            weeklyHours: '4.00',
            credits: '3.00',
            section: '20176'
          },
          {
            cycle: '01',
            courseName: 'OBSERVACIÓN DEL COMPORTAMIENTO',
            grade: '05',
            approvalStatus: 'Retirado',
            catalogNumber: '100000PS23',
            numberTimes: '1',
            weeklyHours: '3.00',
            credits: '3.00',
            section: '20177'
          },
          {
            cycle: '01',
            courseName: 'NIVELACIÓN DE REDACCIÓN',
            grade: '08',
            approvalStatus: 'En Curso',
            catalogNumber: '100000X101',
            numberTimes: '1',
            weeklyHours: '4.00',
            credits: '4.00',
            section: '20180'
          },
          {
            cycle: '01',
            courseName: 'NIVELACIÓN DE MATEMÁTICA-HUMANIDADES',
            grade: '13',
            approvalStatus: 'Convalidado',
            catalogNumber: '100000X103',
            numberTimes: '1',
            weeklyHours: '4.00',
            credits: '4.00',
            section: '20179'
          },
          {
            cycle: '01',
            courseName: 'INTRODUCCIÓN A LA VIDA UNIVERSITARIA: PSICOLOGÍA',
            grade: '11',
            approvalStatus: 'Desaprobado',
            catalogNumber: '200000PS21',
            numberTimes: '1',
            weeklyHours: '3.00',
            credits: '3.00',
            section: '20181'
          }
        ]
      },
      {
        name: '2021 - Ciclo 1 Marzo',
        items: [
          {
            cycle: '02',
            courseName: 'INGLÉS II',
            grade: '01',
            approvalStatus: 'Desaprobado',
            catalogNumber: '100000N05I',
            numberTimes: '1',
            weeklyHours: '3.00',
            credits: '3.00',
            section: '22459'
          },
          {
            cycle: '01',
            courseName: 'AUTOCONOCIMIENTO',
            grade: '04',
            approvalStatus: 'Desaprobado',
            catalogNumber: '100000PS22',
            numberTimes: '2',
            weeklyHours: '4.00',
            credits: '3.00',
            section: '15242'
          },
          {
            cycle: '01',
            courseName: 'OBSERVACIÓN DEL COMPORTAMIENTO',
            grade: '04',
            approvalStatus: 'Desaprobado',
            catalogNumber: '100000PS23',
            numberTimes: '2',
            weeklyHours: '3.00',
            credits: '3.00',
            section: '15243'
          },
          {
            cycle: '02',
            courseName: 'TECNOLOGÍAS DEL APRENDIZAJE',
            grade: '14',
            approvalStatus: 'Aprobado',
            catalogNumber: '100000PS26',
            numberTimes: '1',
            weeklyHours: '3.00',
            credits: '2.00',
            section: '22241'
          },
          {
            cycle: '02',
            courseName: 'PSICOLOGÍA DEL DESARROLLO I: APRENDIZAJE DE SERVICIO',
            grade: '05',
            approvalStatus: 'Desaprobado',
            catalogNumber: '100000PS27',
            numberTimes: '1',
            weeklyHours: '5.00',
            credits: '4.00',
            section: '15248'
          },
          {
            cycle: '00',
            courseName: 'NIVELACIÓN DE REDACCIÓN',
            grade: '06',
            approvalStatus: 'Desaprobado',
            catalogNumber: '100000X101',
            numberTimes: '2',
            weeklyHours: '4.00',
            credits: '4.00',
            section: '15240'
          },
          {
            cycle: '01',
            courseName: 'INTRODUCCIÓN A LA VIDA UNIVERSITARIA: PSICOLOGÍA',
            grade: '00',
            approvalStatus: 'Desaprobado',
            catalogNumber: '200000PS21',
            numberTimes: '2',
            weeklyHours: '3.00',
            credits: '3.00',
            section: '15244'
          }
        ]
      },
      {
        name: '2021 - Ciclo 2 Agosto',
        items: [
          {
            cycle: '01',
            courseName: 'INTRODUCCIÓN A LA PSICOLOGÍA',
            grade: ' ',
            approvalStatus: 'Retirado',
            catalogNumber: '100000P22S',
            numberTimes: 'null',
            weeklyHours: '4.00',
            credits: '4.00',
            section: '17352'
          },
          {
            cycle: '01',
            courseName: 'OBSERVACIÓN DEL COMPORTAMIENTO',
            grade: ' ',
            approvalStatus: 'Retirado',
            catalogNumber: '100000PS23',
            numberTimes: 'null',
            weeklyHours: '3.00',
            credits: '3.00',
            section: '7313'
          },
          {
            cycle: '02',
            courseName: 'PSICOLOGÍA DEL DESARROLLO I: APRENDIZAJE DE SERVICIO',
            grade: '03',
            approvalStatus: 'Desaprobado',
            catalogNumber: '100000PS27',
            numberTimes: '2',
            weeklyHours: '5.00',
            credits: '4.00',
            section: '18844'
          },
          {
            cycle: '04',
            courseName: 'ESTADÍSTICA DESCRIPTIVA PARA PSICOLOGÍA',
            grade: '02',
            approvalStatus: 'Desaprobado',
            catalogNumber: '100000PS35',
            numberTimes: '1',
            weeklyHours: '4.00',
            credits: '4.00',
            section: '21526'
          },
          {
            cycle: '01',
            courseName: 'NIVELACIÓN DE REDACCIÓN',
            grade: ' ',
            approvalStatus: 'Retirado',
            catalogNumber: '100000X101',
            numberTimes: 'null',
            weeklyHours: '4.00',
            credits: '4.00',
            section: '7353'
          },
          {
            cycle: '01',
            courseName: 'INTRODUCCIÓN A LA VIDA UNIVERSITARIA: PSICOLOGÍA',
            grade: ' ',
            approvalStatus: 'Retirado',
            catalogNumber: '200000P21S',
            numberTimes: 'null',
            weeklyHours: '3.00',
            credits: '3.00',
            section: '12691'
          }
        ]
      },
      {
        name: '2022 - Ciclo 1 Marzo',
        items: [
          {
            cycle: '02',
            courseName: 'INGLÉS II',
            grade: '13',
            approvalStatus: 'Aprobado',
            catalogNumber: '100000N05I',
            numberTimes: '2',
            weeklyHours: '3.00',
            credits: '3.00',
            section: '8039'
          },
          {
            cycle: '01',
            courseName: 'INTRODUCCIÓN A LA PSICOLOGÍA',
            grade: '18',
            approvalStatus: 'Aprobado',
            catalogNumber: '100000P22S',
            numberTimes: '3',
            weeklyHours: '4.00',
            credits: '4.00',
            section: '39348'
          },
          {
            cycle: '01',
            courseName: 'OBSERVACIÓN DEL COMPORTAMIENTO',
            grade: '17',
            approvalStatus: 'Aprobado',
            catalogNumber: '100000PS23',
            numberTimes: '3',
            weeklyHours: '3.00',
            credits: '3.00',
            section: '4090'
          },
          {
            cycle: '04',
            courseName: 'ESTADÍSTICA DESCRIPTIVA PARA PSICOLOGÍA',
            grade: ' ',
            approvalStatus: 'Retirado',
            catalogNumber: '100000PS35',
            numberTimes: 'null',
            weeklyHours: '4.00',
            credits: '4.00',
            section: '12643'
          },
          {
            cycle: '01',
            courseName: 'INTRODUCCIÓN A LA VIDA UNIVERSITARIA: PSICOLOGÍA',
            grade: '18',
            approvalStatus: 'Aprobado',
            catalogNumber: '200000P21S',
            numberTimes: '3',
            weeklyHours: '3.00',
            credits: '3.00',
            section: '39638'
          }
        ]
      },
      {
        name: '2022 - Ciclo 2 Agosto',
        items: [
          {
            cycle: '03',
            courseName: 'INGLÉS III',
            grade: '07',
            approvalStatus: 'Desaprobado',
            catalogNumber: '100000N08I',
            numberTimes: '1',
            weeklyHours: '3.00',
            credits: '3.00',
            section: '14342'
          },
          {
            cycle: '02',
            courseName: 'BASES BIOLÓGICAS DEL COMPORTAMIENTO',
            grade: '15',
            approvalStatus: 'Aprobado',
            catalogNumber: '100000PS25',
            numberTimes: '1',
            weeklyHours: '4.00',
            credits: '4.00',
            section: '59908'
          },
          {
            cycle: '02',
            courseName: 'PSICOLOGÍA DEL DESARROLLO I: APRENDIZAJE DE SERVICIO',
            grade: '11',
            approvalStatus: 'Desaprobado',
            catalogNumber: '100000PS27',
            numberTimes: '3',
            weeklyHours: '5.00',
            credits: '4.00',
            section: '14800'
          },
          {
            cycle: '02',
            courseName: 'OBSERVACIÓN Y ENTREVISTA',
            grade: '11',
            approvalStatus: 'Desaprobado',
            catalogNumber: '100000PS28',
            numberTimes: '1',
            weeklyHours: '4.00',
            credits: '4.00',
            section: '14986'
          },
          {
            cycle: '04',
            courseName: 'ESTADÍSTICA DESCRIPTIVA PARA PSICOLOGÍA',
            grade: '10',
            approvalStatus: 'Desaprobado',
            catalogNumber: '100000PS35',
            numberTimes: '2',
            weeklyHours: '4.00',
            credits: '4.00',
            section: '14428'
          }
        ]
      }
    ];
  }
}
